import { useQuery } from '@tanstack/react-query';
import { getSuchenPlusStatus } from '@/api/suchenPlus/getSuchenPlusStatus';

type SuchenPlusStatusQueryOptions = {
  enabled?: boolean;
  useErrorBoundary?: boolean;
};

export const useGetSuchenPlusStatus = (options: SuchenPlusStatusQueryOptions = {}) => {
  const { data, isError } = useQuery({
    queryKey: ['suchen-plus-status'],
    queryFn: getSuchenPlusStatus,
    ...options,
  });

  return {
    suchenPlusStatus: data,
    isError,
  };
};
